<!-- ROOT: app.vue -->
<!-- Root application shell — mounts NuxtLayout and NuxtPage. -->

<template>
  <v-app>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </v-app>
</template>
